import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import logo from '../../images/logo.png';
import 'aos/dist/aos.css';
import { useLocation } from 'react-router-dom';
import { SOCIAL_LINKS } from '../../config/socials';
import FacebookTablerIcon from '../../assets/icons/FacebookTablerIcon';
import TikTokTablerIcon from '../../assets/icons/TikTokTablerIcon';
import InstagramTablerIcon from '../../assets/icons/InstagramTablerIcon';

const ALLOWED_HERO_PATHS = [
  '/',
  '/terms-of-service',
  '/privacy-policy',
  '/thank-you',
  '/order-failed',
  '/failed-order',
];

const ICONS = [FacebookTablerIcon, TikTokTablerIcon, InstagramTablerIcon];

const Header: React.FC = () => {
  const location = useLocation();
  const isHomePage = ALLOWED_HERO_PATHS.includes(location.pathname);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const onScroll = () => {
      setIsScrolled(
        window.scrollY > (isHomePage ? 0.6 : 0) * window.innerHeight
      );
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`position-absolute w-100 py-3 ${
        isScrolled || !isHomePage
          ? `fixed ${isScrolled ? 'shadow-sm' : ''}`
          : ''
      }`}
      id="header"
      style={{ zIndex: 1000, transition: 'background-color 0.3s ease, top 0.3s ease' }}
    >
      <div className="container-md d-flex justify-content-center align-items-center justify-content-md-between">
        <a href="/">
          <img className="header-logo" src={logo} alt="Logo" />
        </a>
        <div className="d-none d-md-block">
          {SOCIAL_LINKS.map((link, i) => {
            const Icon = ICONS[i];
            return (
              <a
                key={link.label}
                className="text-primary bg-light shadow-sm d-inline-flex justify-content-center align-items-center mx-1 rounded-2 media-buttons"
                style={{ width: 48, fontSize: 30, height: 48 }}
                href={link.href}
                aria-label={link.label}
                target="_blank"
                rel="noreferrer"
              >
                <Icon />
              </a>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;
